import React from 'react'
import ModalContainer from '../ModalContainer/ModalContainer';
import Button from '../Button/Button';


const ConfirmationModal = props => {

  const {confirmationBtnTitle,cancelBtnTitle='CANCEL',cancel,confirm,children} = props;

  return (
    <ModalContainer close={cancel}>
      <div style={{textAlign:'center'}}>
        {children}
        <div style={{height:'20px'}} />
        <Button grey click={cancel} marginRight='10px'>{cancelBtnTitle}</Button>
        <Button click={confirm}>{confirmationBtnTitle}</Button>
      </div>
    </ModalContainer>
  );
};

export default ConfirmationModal;
